import React from "react";
import styled from "styled-components";
import { caseStatusLabel, caseStatusTone } from "../../utils/supportCaseVocabulary";

/**
 * CaseStatusChip: the ONE way a support case status is drawn in this client.
 *
 * Both the list and the detail header use it, so a case can never read
 * "Waiting on you" in amber on one screen and "PENDING_CUSTOMER" in grey on
 * the other. The wording and the tone both come out of
 * utils/supportCaseVocabulary.js; only the palette lives here.
 */
const TONES = {
  info: { bg: "#eef4ff", border: "#c7d8f7", text: "#1d4ed8" },
  warn: { bg: "#fffbeb", border: "#fde68a", text: "#b45309" },
  good: { bg: "#f0fdf4", border: "#bbf7d0", text: "#15803d" },
  muted: { bg: "#f4f5f6", border: "#e2e5e8", text: "#6b7280" },
};

const CaseStatusChip = ({ status, size = "md", className }) => {
  const tone = TONES[caseStatusTone(status)] || TONES.muted;
  return (
    <Chip $tone={tone} $size={size} className={className}>
      {caseStatusLabel(status)}
    </Chip>
  );
};

const Chip = styled.span`
  display: inline-block;
  flex: none;
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.2px;
  white-space: nowrap;
  padding: ${(p) => (p.$size === "sm" ? "3px 9px" : "5px 12px")};
  font-size: ${(p) => (p.$size === "sm" ? "11px" : "12.5px")};
  background: ${(p) => p.$tone.bg};
  border: 1px solid ${(p) => p.$tone.border};
  color: ${(p) => p.$tone.text};
`;

export default CaseStatusChip;
